export const browser = {
  msEdge: 'MS Edge',
  edge: 'Edge',
  opera: 'Opera',
  chrome: 'Chrome',
  msIE: 'MS IE',
  firefox: 'Mozilla Firefox',
  safari: 'Safari',
  metamask: 'Meta Mask',
  other: 'othre',
};

export const getAgent = () => {
  return window.navigator.userAgent.toLowerCase();
};

export const getBrowserName = () => {
  const agent = window.navigator.userAgent.toLowerCase();
  if (agent.indexOf('metamaskmobile') > -1) {
    return browser.metamask;
  }
  // edge 브라우저에서는 agent에 chrome, safari 모두 표시되므로 반드시 크롬, 사파리보다 먼저 체크한다.
  if (agent.indexOf('edge') > -1) {
    return browser.msEdge;
  }
  if (agent.indexOf('edg/') > -1) {
    return browser.edge;
  }
  if (agent.indexOf('opr') > -1) {
    return browser.opera;
  }
  // 크롬 브라우저에서는 agent에 chrome, safari 모두 표시되므로 반드시 사파리보다 먼저 체크한다.
  if (agent.indexOf('chrome') > -1) {
    return browser.chrome;
  }
  if (agent.indexOf('trident') > -1) {
    return browser.msIE;
  }
  if (agent.indexOf('firefox') > -1) {
    return browser.firefox;
  }
  if (agent.indexOf('safari') > -1) {
    return browser.safari;
  }
  return browser.other;
};

export const isValidBrowser = () => {
  const browserName = getBrowserName();
  return (
    browserName === browser.chrome ||
    browserName === browser.safari ||
    browserName === browser.edge ||
    browserName === browser.msEdge
  );
};

export const isSameBrowser = (name) => {
  const browserName = getBrowserName();
  return name === browserName;
};

export const isChrome = () => {
  return isSameBrowser(browser.chrome);
};

export const isSupportedBrowser = () => {
  return (
    isSameBrowser(browser.chrome) ||
    isSameBrowser(browser.safari) ||
    isSameBrowser(browser.edge)
  );
};

export const isNotChrome = () => {
  return isSameBrowser(browser.chrome) !== true;
};

export const isMetaMask = () => {
  return isSameBrowser(browser.metamask);
};
